import { userAPI } from '@/services-ts/axios'
import type { IPayloadCompanySetting } from '@/types/Request'
import type { IEmployeeTypeStore } from '@/types/Store/State'
import { defineStore } from 'pinia'
import {
  createSimpleListItem,
  deleteSimpleListItem,
  fetchSimpleList,
  updateSimpleListItem,
} from './simpleListHelpers'

export const useEmployeeWorkerTypeStore = defineStore('employeeWorkerType', {
  state: (): IEmployeeTypeStore => ({
    employeeTypeList: [],
  }),

  actions: {
    async GetEmployeeTypeList(): Promise<void> {
      const list = await fetchSimpleList(() => userAPI.EmployeeTypeServices.GetEmployeeTypeList())
      if (list) this.employeeTypeList = list
    },

    async CreateEmployeeType(Name: string): Promise<boolean> {
      const item = await createSimpleListItem(
        name => userAPI.EmployeeTypeServices.CreateEmployeeType(name),
        Name,
      )
      if (item) this.employeeTypeList.push(item)
      return !!item
    },

    async UpdateEmployeeType(payload: IPayloadCompanySetting): Promise<boolean> {
      const status = await updateSimpleListItem(
        p => userAPI.EmployeeTypeServices.UpdateEmployeeType(p),
        payload,
      )
      if (status) {
        this.employeeTypeList = this.employeeTypeList.map(employeeType =>
          employeeType.id === payload.Id
            ? { ...employeeType, name: payload.Name, firstValue: payload.Name }
            : employeeType,
        )
      }
      return status
    },

    async DeleteEmployeeType(Id: string): Promise<void> {
      const status = await deleteSimpleListItem(
        id => userAPI.EmployeeTypeServices.DeleteEmployeeType(id),
        Id,
      )
      if (status) {
        this.employeeTypeList = this.employeeTypeList.filter(employeeType => employeeType.id !== Id)
      }
    },
  },
})
